import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/safiruni/front/app/[lang]/services/components/ServicesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/safiruni/front/components/Home/Opinion/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/safiruni/front/components/shared/ReservationSection/index.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/safiruni/front/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www/safiruni/front/public/images/like.svg");
;
import(/* webpackMode: "eager" */ "/var/www/safiruni/front/public/images/starB.svg");
;
import(/* webpackMode: "eager" */ "/var/www/safiruni/front/public/images/visit.svg");
